import holidays from '@/content/global/holidays';

export const state = () => ({
  notifications: {},

  holidays: {
    dates: holidays.dates || [],
    bannerDates: holidays.bannerDates || [],
    message: holidays.message || '',
  },
});

export const getters = {
  holidays(state) {
    return {
      dates: [],
      bannerDates: [],
      message: '',
      ...state.holidays,
    };
  },
};

export const mutations = {
  setHolidays(state, holidaysData) {
    if (holidaysData) {
      state.holidays = holidaysData;
    }
  },

  setNotifications(state, data) {
    state.notifications = data;
  },
};

export const actions = {
  fetchHolidays({ commit }) {
    // Static content - already loaded at import time
    commit('setHolidays', {
      dates: holidays.dates || [],
      bannerDates: holidays.bannerDates || [],
      message: holidays.message || '',
    });

    return Promise.resolve();
  },

  fetchNotifications({ commit }) {
    return this.$axios.get('/v0/app/my/notifications').then((res) => {
      commit('setNotifications', res.data);
    });
  },
};
